export const isShortcutExternal = (
  shortcut: Nullable<string> | undefined,
  url: Nullable<string> | undefined
) => Boolean(url && shortcut === 'External');
